import { About } from './About'
import Banners from './Banners'
import Footer from './Footer'
import { Header } from './Header'
import { Products } from './Products'
import Spec from './Spec'
import Trailers from './Trailers'

function App() {
    return (
        <>
            <div className='bg-space'>
                <Header />
                <div className='my-20 md:my-40'>
                    <h1 className='text-white/80 text-md md:text-lg  italic text-center tracking-widest'>
                        The fate of two races depends on you.
                    </h1>
                </div>
                <About />
                <Trailers />
                <Products />
                <Banners />
                <Spec />
                <Footer />
            </div>
        </>
    )
}

export default App
